import "./SingleRecipeTemplate.module.css"
import Navigation from "@/reusable_sections/Header"
import SingleRecipeTemplateSection from "./sections/SingleRecipeTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleRecipeTemplatePage() {

  return (
    <div>
      <Navigation />
      <SingleRecipeTemplateSection />
      <Footer />
    </div>
  )
}
